import React, { useState, useEffect } from 'react'
import { createClient } from '@supabase/supabase-js'
import './ResetPassword.css'

// Supabase配置
const supabaseUrl = 'https://ieumcctsndtnqarvqxwq.supabase.co'
const supabaseKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlldW1jY3RzbmR0bnFhcnZxeHdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwMzA0NDksImV4cCI6MjA3MDYwNjQ0OX0.fgNh8aStmxm9pzNjlzO5G0bhOs0hLSqiIHXW9eqENoo'

const supabase = createClient(supabaseUrl, supabaseKey)

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  })
  const [passwordStrength, setPasswordStrength] = useState({
    strength: 'none',
    text: '',
    color: '',
  })
  const [confirmError, setConfirmError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [error, setError] = useState('')

  // 检查密码强度
  const checkPasswordStrength = password => {
    if (password.length === 0) return { strength: 'none', text: '', color: '' }

    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)
    const hasNumbers = /\d/.test(password)
    const hasLength = password.length >= 8

    const score = [hasUpperCase, hasLowerCase, hasNumbers, hasLength].filter(
      Boolean
    ).length

    if (score === 4) {
      return {
        strength: 'strong',
        text: '密码强度：强',
        color: 'strength-strong',
      }
    } else if (score >= 2) {
      return {
        strength: 'medium',
        text: '密码强度：中',
        color: 'strength-medium',
      }
    } else {
      return { strength: 'weak', text: '密码强度：弱', color: 'strength-weak' }
    }
  }

  // 更新密码强度显示
  const updatePasswordStrength = () => {
    const { newPassword, confirmPassword } = formData

    const strength = checkPasswordStrength(newPassword)
    setPasswordStrength(strength)

    if (confirmPassword && newPassword !== confirmPassword) {
      setConfirmError('两次输入的密码不一致')
    } else {
      setConfirmError('')
    }
  }

  // 计算按钮是否应该禁用
  const isButtonDisabled = () => {
    const { newPassword, confirmPassword } = formData
    const strength = checkPasswordStrength(newPassword)
    const passwordsMatch = newPassword === confirmPassword
    const isStrongPassword = strength.strength === 'strong'

    return (
      !(newPassword && confirmPassword && passwordsMatch && isStrongPassword) ||
      isLoading
    )
  }

  // 处理输入变化
  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  // 处理表单提交
  const handleSubmit = async e => {
    e.preventDefault()

    if (isButtonDisabled()) {
      return
    }

    setIsLoading(true)
    setError('')

    try {
      const { error } = await supabase.auth.updateUser({
        password: formData.newPassword,
      })

      if (error) {
        setError('重置失败：' + error.message)
      } else {
        setIsSuccess(true)
        // 3秒后可以重定向到应用
        setTimeout(() => {
          // 这里可以重定向到你的应用
          // window.location.href = 'your-app-scheme://'
          alert('密码重置成功！请返回应用使用新密码登录。')
        }, 3000)
      }
    } catch (error) {
      setError('重置失败：' + error.message)
    } finally {
      setIsLoading(false)
    }
  }

  // 监听formData变化，更新密码强度显示
  useEffect(() => {
    updatePasswordStrength()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData])

  // 页面加载时检查URL参数
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const accessToken = urlParams.get('access_token')
    const refreshToken = urlParams.get('refresh_token')

    if (accessToken && refreshToken) {
      // 设置用户会话
      supabase.auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken,
      })
    }
  }, [])

  if (isSuccess) {
    return (
      <div className="reset-password-container">
        <div className="reset-password-box">
          <h1 className="title">重置密码</h1>
          <div className="success-message">
            密码重置成功！请返回应用使用新密码登录。
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="reset-password-container">
      <div className="reset-password-box">
        <h1 className="title">重置密码</h1>
        <p className="subtitle">请输入您的新密码</p>

        <div className="requirements">
          <h4>密码要求：</h4>
          <ul>
            <li>至少8个字符</li>
            <li>包含大小写字母</li>
            <li>包含数字</li>
          </ul>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newPassword">新密码</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              placeholder="请输入新密码"
              value={formData.newPassword}
              onChange={handleInputChange}
              required
            />
            <div className={`password-strength ${passwordStrength.color}`}>
              {passwordStrength.text}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">确认密码</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="请再次输入新密码"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
            />
            {confirmError && (
              <div className="error-message">{confirmError}</div>
            )}
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            className={`btn ${isLoading ? 'loading' : ''}`}
            disabled={isButtonDisabled()}
          >
            {isLoading ? '重置中...' : '重置密码'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default ResetPassword
